// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialMedia_wrapper__QAJHs","socials":"SocialMedia_socials__RWRN0"};